import { Link } from "react-router-dom";

const categoryLinks = [
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/movie", label: "电影" },
  { to: "/category/variety", label: "综艺" },
];

const quickLinks = [
  { to: "/", label: "网站首页" },
  { to: "/search?q=热播", label: "热播推荐" },
  { to: "/category/tv", label: "最新更新" },
  { to: "/category/movie", label: "高分片单" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-50 border-t border-primary-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-2xl"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                爱看<span className="text-primary-500">视频</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              爱看视频是一家提供影视剧、电影与综艺节目在线观看的综合影视平台，
              汇聚最新剧集、热门电影与口碑综艺，为影视爱好者带来便捷的浏览与发现体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">影视分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快捷入口</h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 爱看视频 AikanVideo · 本站影视内容均为演示数据
          </p>
          <p className="text-xs text-foreground-500">
            友情提示：视频播放功能仅为界面演示，正式上线需接入播放服务
          </p>
        </div>
      </div>
    </footer>
  );
}